/**
 * CMS Config
 */
const cmsConfig = {
  relatedArticles: 3,
  relatedProjects: 3,
}
export default cmsConfig
